import { useContext } from 'react';
import {
  WalletConnectContext,
  type WalletConnectContextValue,
} from '@/contexts/WalletConnectContext';

/**
 * Access the WalletConnect engine. Returns null when used outside the provider
 * (e.g. on unauthenticated routes) so callers can render nothing gracefully.
 */
export function useWalletConnect(): WalletConnectContextValue | null {
  return useContext(WalletConnectContext);
}
